import React from 'react';
import { Box, IconButton, Modal, Stack, Typography, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { addNewActivity, updateActivity } from '../../store/actions';
import { tokens } from '../../theme';
import ActivityForm from './ActivityForm';

// One modal for both "add" and "update": pass an existing `activity` to edit it,
// or leave it out to create a new one.
const emptyValues = {
    name: '',
    description: '',
    rate: '',
    minimum_pax: 1,
    maximum_pax: 0,
    inclusions: '',
    exclusions: '',
    img: [],
};

function ActivityFormModal({ open, onClose, activity, onSuccess }) {
    const dispatch = useDispatch();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isLoading = useSelector(({ loading }) => loading);

    const editMode = !!activity?._id;

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { sm: 460, xs: '92%' },
        maxHeight: '92vh',
        overflowY: 'auto',
        bgcolor: colors.primary[400],
        outline: 'none',
        boxShadow: 24,
        borderRadius: 2,
        p: 3,
    };

    const initialValues = editMode
        ? {
            id: activity._id,
            name: activity.name ?? '',
            description: activity.description ?? '',
            rate: activity.rate ?? '',
            minimum_pax: activity.minimum_pax ?? 1,
            maximum_pax: activity.maximum_pax ?? 0,
            inclusions: activity.inclusions ?? '',
            exclusions: activity.exclusions ?? '',
            img: activity.img ? [activity.img] : [],
        }
        : { ...emptyValues, img: [] };

    const handleSubmit = async (values) => {
        const payload = {
            ...values,
            rate: Number(values.rate) || 0,
            minimum_pax: Number(values.minimum_pax) || 1,
            maximum_pax: Number(values.maximum_pax) || 0,
            img: values.img?.length ? values.img[0] : '',
        };
        const success = await dispatch(
            editMode ? updateActivity(payload) : addNewActivity(payload)
        );
        if (success) {
            onSuccess?.();
            onClose();
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" fontWeight="bold" color={colors.grey[100]}>
                        {editMode ? 'Update activity' : 'Add new activity'}
                    </Typography>
                    <IconButton size="small" onClick={onClose}>
                        <Close fontSize="small" />
                    </IconButton>
                </Stack>
                <ActivityForm
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    isLoading={isLoading}
                    editMode={editMode}
                />
            </Box>
        </Modal>
    );
}

export default ActivityFormModal;
